import axios from 'axios';
import { CAMPAIGN_PAYLOAD_LITE_CUSTOMER } from '../config';

const SUCCESS_REGISTRATION_MESSAGE = 'Your registration has been submitted. You will receive an email with the status of your brand registration which it could take up to 24hrs.';
const FAILED_REGISTRATION_MESSAGE = 'Oops, something went wrong with your brand registration. Please email Support@liondesk.com to report your issue.';
const initialState = {
  form: {},
  error: false,
  success: false,
  errorMessage: '',
  successMessage: '',
  isLoading: false,
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setForm(store, { form }) {
      store.form = form;
    },
    setError(store, { hasError, message }) {
      store.error = hasError;
      store.errorMessage = message;
    },
    setSuccess(store, { success, message }) {
      store.success = success;
      store.successMessage = message;
    },
    resetError(store) {
      store.error = false;
      store.errorMessage = '';
    },
    resetSuccess(store) {
      store.success = false;
      store.successMessage = '';
    },
    setIsLoading(store, value) {
      store.isLoading = value;
    },
  },
  actions: {
    async saveLiteCustomer({ commit, state }) {
      const { form } = state;
      const countryCode =  '+1';
      const payload = {
        customer_information: {
          first_name: form.firstName,
          last_name: form.lastName,
          email: form.email,
          phone_number: `${countryCode}${form.phone}`,
        },
        address: {
          street: form.street,
          city: form.city,
          region: form.state,
          postal_code: form.zipCode,
          iso_country: form.country,
        },
        business_information: {
          brokerage: form.brokerage,
          team_size: form.teamSize,
        },
        campaign: CAMPAIGN_PAYLOAD_LITE_CUSTOMER,
      };

      commit('setIsLoading', true);
      try {
        await axios.post(`${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/register-10dlc/starter`, payload);
        commit('setSuccess', {
          success: true,
          message: SUCCESS_REGISTRATION_MESSAGE,
        });
      } catch (error) {
        commit('setError', {
          hasError: true,
          message: error.data.error || FAILED_REGISTRATION_MESSAGE,
        });
        throw error;
      } finally {
        commit('setIsLoading', false);
      }
    },
  },
};
